import { useEffect, useState } from 'react';
import AdminLayout from '../AdminLayout';
import { getTestimonialsAdmin, addTestimonial, updateTestimonial, deleteTestimonial } from '../../services/adminService';
import { uploadToCloudinary } from '../../utils/uploadToCloudinary';

const BLANK = { image: '', name: '', service: '', feedback: '' };

function TestimonialPanel({ colName, label }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState(BLANK);
  const [uploading, setUploading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [editId, setEditId] = useState(null);

  const load = () => getTestimonialsAdmin(colName).then(d => { setItems(d); setLoading(false); });
  useEffect(() => { load(); }, [colName]);

  const handleFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    try { const url = await uploadToCloudinary(file); setForm(f => ({ ...f, image: url })); }
    catch { alert('Upload failed'); }
    finally { setUploading(false); }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    if (editId) {
      await updateTestimonial(editId, { name: form.name, service: form.service, feedback: form.feedback, image: form.image }, colName);
      setEditId(null);
    } else {
      await addTestimonial({ ...form, order: items.length }, colName);
    }
    setForm(BLANK);
    await load();
    setSaving(false);
  };

  const handleEdit = (item) => { setEditId(item.id); setForm({ image: item.image, name: item.name, service: item.service, feedback: item.feedback }); };
  const handleDelete = async (id) => { if (!window.confirm('Delete?')) return; await deleteTestimonial(id, colName); setItems(p => p.filter(x => x.id !== id)); };

  return (
    <div>
      <div className="admin-section">
        <div className="admin-section-header"><h2>{editId ? 'Edit' : 'Add'} Testimonial</h2></div>
        <div className="admin-section-body">
          <form className="admin-form" onSubmit={handleSubmit} style={{ maxWidth: 540 }}>
            <div><label>Photo</label>
              <label className="upload-box">
                <input type="file" accept="image/*" onChange={handleFile} />
                {uploading ? <p>Uploading…</p> : form.image ? <img src={form.image} alt="" style={{ maxHeight: 80 }} /> : <p>Click to upload photo</p>}
              </label>
            </div>
            <div><label>Client Name</label><input value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} required /></div>
            <div><label>Service</label><input value={form.service} onChange={e => setForm(f => ({ ...f, service: e.target.value }))} placeholder="e.g. Bridal Makeup" required /></div>
            <div><label>Feedback</label><textarea value={form.feedback} onChange={e => setForm(f => ({ ...f, feedback: e.target.value }))} required /></div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button className="a-btn a-btn-primary" type="submit" disabled={saving}>{saving ? 'Saving…' : editId ? 'Update' : 'Add'}</button>
              {editId && <button className="a-btn a-btn-ghost" type="button" onClick={() => { setEditId(null); setForm(BLANK); }}>Cancel</button>}
            </div>
          </form>
        </div>
      </div>

      <div className="admin-section">
        <div className="admin-section-header"><h2>All Testimonials ({items.length})</h2></div>
        <div className="admin-section-body">
          {loading ? <div className="admin-spinner">Loading…</div> : (
            items.length === 0 ? <div className="admin-empty">No testimonials yet</div> : (
              items.map(item => (
                <div key={item.id} className="admin-list-item">
                  <img src={item.image} alt={item.name} className="img-preview" />
                  <div className="admin-list-item-content">
                    <strong>{item.name}</strong> — {item.service}
                    <div style={{ fontSize: 13, color: 'var(--a-text-muted)', marginTop: 4 }}>{item.feedback?.slice(0, 100)}…</div>
                  </div>
                  <div className="admin-list-item-actions">
                    <button className="a-btn a-btn-sm a-btn-ghost" onClick={() => handleEdit(item)}>Edit</button>
                    <button className="a-btn a-btn-sm a-btn-danger" onClick={() => handleDelete(item.id)}>Delete</button>
                  </div>
                </div>
              ))
            )
          )}
        </div>
      </div>
    </div>
  );
}

export default function AdminTestimonials() {
  const [tab, setTab] = useState(0);
  return (
    <AdminLayout title="Testimonials">
      <div className="admin-tabs">
        <button className={`admin-tab${tab === 0 ? ' active' : ''}`} onClick={() => setTab(0)}>Main Testimonials</button>
        <button className={`admin-tab${tab === 1 ? ' active' : ''}`} onClick={() => setTab(1)}>Course Testimonials</button>
      </div>
      {tab === 0 && <TestimonialPanel colName="testimonials" label="Main" />}
      {tab === 1 && <TestimonialPanel colName="testimonials_course" label="Course" />}
    </AdminLayout>
  );
}
